// "Authorized by" label for a Net Checkout order (MVP-9, OPS-02 of
// docs/planning/2026-10-23-net-checkout-pin-and-gate-decoupling-proposal.md).
//
// Reads orders.net_authorization as the API returns it: 'pin' (the caller
// verified the store's PIN), 'store_password' (the caller's session holds
// the store's Shared password pass, P1-1), 'staff' (LEGACY: an order placed
// by own-tenant staff or a Super Admin before 2026-10-30, when staff were
// exempt; nothing writes it now, but those rows still render), or
// null (a Net order built before the PIN rollout, which was never
// credit-authorized by a credential: say so, never "PIN"). An unknown
// future mode is shown verbatim rather than guessed at. ASCII-only.

export const NET_AUTH_NOT_RECORDED = "Not recorded (before PIN rollout)";

export function netAuthorizationLabel(value) {
    if (value === "pin") return "PIN";
    if (value === "store_password") return "Store password";
    if (value === "staff") return "Staff";
    if (!value) return NET_AUTH_NOT_RECORDED;
    return String(value);
}
